import {http} from './config/config-relation-register'

export default{
    listar:async(token, itens_pagina,pagina,filter)=>{
        if(itens_pagina,pagina){
            return  http.get('empresas?itens_pagina='+itens_pagina+'&pagina='+pagina+'&filter='+encodeURIComponent(filter),{
                headers:{
                    'Authorization':token
                }
            }) 
        }else{
            return  http.get('empresas',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, item)=>{
        return http.post('empresas',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('empresas/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('empresas/'+item.id_empresa,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}